import ImageWithFallback from "@/components/ImageWithFallback";

export const columns = () => {
  return [
    {
      accessorKey: "order",
      header: "Order",
      size: 60,
      cell: ({ row }) => (
        <div className={"flex justify-center"}>{row.getValue("order")}</div>
      ),
    },
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
      enableSorting: true,
    },
    {
      accessorKey: "icon_url",
      header: "Icon",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("icon_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: "Brand",
    },
  ];
};
